export enum Protocol {
  RFQ,
  ORDER,
}

export namespace Protocol {
  let elements = [Protocol.RFQ, Protocol.ORDER];
  let alias = "com.bcdfx.model.Protocol";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
